import React, { Component } from 'react';
import MainSettingContext from './MainSettingContext';
import './App.css';
import Footer from './footer';
import instance from "./axios-instance";
import { getMainSettingCached } from "./sharedApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import Swal from 'sweetalert2';
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
    static contextType = MainSettingContext;

  constructor(props) {
    super(props);
    this.state = {
      rewardlist: [],
      activePage: 1,
      isActive: false,
      categorylist: [],
      activeTab: 1,
      formData: {},
      errors: {},
      formSubmitted: false,
      loading: true,
      pagecount: 1,
      username: "",
      userid: null,
      showpass: true,
      point: 0,
      balance: 0,
      products_page_count: 1,
      loginstate: false,
      firstname: null,
      lastname: null,
      alert: null,
      modalOpen: false,
      handleClose: false,
      token: window.localStorage.getItem("token"),
      type: "",
      linelink: "",
      amount: "",
      remark: "",
      name: "",
      password: "",
      left: false,

      // remember options
      rememberUser: true,   // จำผู้ใช้ (จะถูกบังคับให้ true ถ้า rememberPass = true)
      rememberPass: false,  // จำรหัสผ่าน (ไม่แนะนำด้าน security แต่ทำตามโจทย์)
    };
   // this.login = this.login.bind(this);
  }

  // ====== LocalStorage keys ======
  LS_KEYS = {
    USERNAME: "LOGIN_USERNAME",
    PASSWORD: "LOGIN_PASSWORD",
    REM_USER: "REMEMBER_USER",
    REM_PASS: "REMEMBER_PASS",
  };

  // โหลดค่าที่เคยจำไว้
  loadRemembered = () => {
    try {
      const remPass = localStorage.getItem(this.LS_KEYS.REM_PASS) === "true";
      const remUser = remPass ? true : (localStorage.getItem(this.LS_KEYS.REM_USER) === "true"); // ถ้าจำ pass ต้องจำ user ด้วย
      const username = (remUser || remPass) ? (localStorage.getItem(this.LS_KEYS.USERNAME) || "") : "";
      const password = remPass ? (localStorage.getItem(this.LS_KEYS.PASSWORD) || "") : "";
      this.setState({ rememberUser: remUser, rememberPass: remPass, username, password });
    } catch (e) { /* ignore */ }
  };

  // บันทึกค่าที่เลือกจำไว้ (เรียกหลังล็อกอินสำเร็จ)
  saveRemembered = () => {
    try {
      let { rememberUser, rememberPass, username, password } = this.state;
      if (rememberPass) rememberUser = true; // บังคับจำ user ถ้าจำ pass

      localStorage.setItem(this.LS_KEYS.REM_USER, String(rememberUser));
      localStorage.setItem(this.LS_KEYS.REM_PASS, String(rememberPass));

      if (rememberUser || rememberPass) {
        localStorage.setItem(this.LS_KEYS.USERNAME, username || "");
      } else {
        localStorage.removeItem(this.LS_KEYS.USERNAME);
      }

      if (rememberPass) {
        // คำเตือน: เก็บ plain text มีความเสี่ยงด้านความปลอดภัย
        localStorage.setItem(this.LS_KEYS.PASSWORD, password || "");
      } else {
        localStorage.removeItem(this.LS_KEYS.PASSWORD);
      }
    } catch (e) { /* ignore */ }
  };

  clearRemembered = () => {
    try {
      localStorage.removeItem(this.LS_KEYS.USERNAME);
      localStorage.removeItem(this.LS_KEYS.PASSWORD);
      localStorage.removeItem(this.LS_KEYS.REM_USER);
      localStorage.removeItem(this.LS_KEYS.REM_PASS);
    } catch (e) { /* ignore */ }
  };

  changepass = (e) => {
    e.preventDefault();
    this.setState((s) => ({ showpass: !s.showpass }));
  }

  login = (e) => {
    e.preventDefault();
    this.validateLoginForm();
  }

  notify = async (mode, msg) => {
    const opt = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    };
    if (mode === "success") await toast.success(msg, opt);
    else if (mode === "warning") await toast.warning(msg, opt);
    else if (mode === "error") await toast.error(msg, opt);
    else if (mode === "info") await toast.info(msg, opt);
    await this.waitnotify();
  }

  waitnotify = async () => {
    setTimeout(() => { /* noop */ }, 5000);
  }

  validateLoginForm = async () => {
    const { username, password } = this.state;

    await instance.post("/api/v1/userlogin", {
      userid: username,
      password: password,
      System: Systems,
      Function: 'validateLoginForm-navbar.js'
    })
      .then(async (res) => {
        if (res.data.status === 200) {
          await localStorage.setItem('auth_token', res.data.token);

          // บันทึกค่าจำผู้ใช้/รหัสผ่าน ตามที่ติ๊กไว้
          this.saveRemembered();

          this.setState({
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            firstname: res.data.message.firstname,
            lastname: res.data.message.lastname,
            point: res.data.message.Point,
            balance: res.databalance,
            loginstate: true,
          });
          await this.notify("success", 'เข้าสุ่ระบบ กำลังเปลี่ยนเส้นทาง');
          setTimeout(() => { window.location.href = '/' }, 600); // [2026-10-25] เดิมรอ 2 วิ ก่อนเข้าเว็บ → 0.6 วิ (พอให้เห็นข้อความสำเร็จ)
        }
        else if (res.data.status === 401) {
          Swal.fire({ title: 'error!', text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง', icon: 'error', confirmButtonText: 'ตกลง' });
        }
        else {
          Swal.fire({ title: 'error!', text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง', icon: 'error', confirmButtonText: 'ตกลง' });
        }
      }).catch(() => {
        Swal.fire({ title: 'error!', text: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้', icon: 'error', confirmButtonText: 'ตกลง' });
      });
  }

  async componentDidMount() {
    // โหลด username/password ถ้าเคยจำไว้
    this.loadRemembered();

    try {
      await getMainSettingCached() /* [2026-10-25] ร่วม request/cache กับ main.js (sharedApi) */
        .then((res) => {
          if (res.data.status === 200) {
            const datas = res.data.message;
            this.setState({
              linelink: datas?.[1]?.value,
              System: res.data?.tblcatagoryx?.[0]?.System
            });
          }
        });
    } catch (error) {
      // ignore
    }
  }

  onChange = (event) => {
    let nam, val;
    if (event.target?.name === undefined) {
      nam = event.name;
      val = event.value;
    } else {
      nam = event.target.name;
      val = event.target.value;
    }
    this.setState({ [nam]: val });
  };

  // toggle checkbox
  onToggleRemember = (key) => (e) => {
    const checked = !!e.target.checked;

    if (key === 'rememberPass') {
      // ถ้าเลือกจำรหัสผ่าน → บังคับจำผู้ใช้ด้วย
      this.setState(
        { rememberPass: checked, rememberUser: checked ? true : this.state.rememberUser },
        () => {
          localStorage.setItem(this.LS_KEYS.REM_PASS, String(this.state.rememberPass));
          localStorage.setItem(this.LS_KEYS.REM_USER, String(this.state.rememberUser));
          if (!this.state.rememberPass) localStorage.removeItem(this.LS_KEYS.PASSWORD);
          if (!this.state.rememberUser) localStorage.removeItem(this.LS_KEYS.USERNAME);
        }
      );
    } else {
      this.setState({ [key]: checked }, () => {
        localStorage.setItem(this.LS_KEYS.REM_USER, String(this.state.rememberUser));
        if (!this.state.rememberUser) localStorage.removeItem(this.LS_KEYS.USERNAME);
      });
    }
  };

  render() {
    const { username, password, rememberPass, showpass } = this.state;

    return (
      <form className="sol-form" onSubmit={(e) => { e.preventDefault(); this.login(e); }}>
        <div className="sol-field">
          <input
            type="text"
            id="username"
            name="username"
            value={username}
            onChange={this.onChange}
            className="sol-input"
            maxLength={10}
            minLength={10}
            placeholder="เบอร์โทรศัพท์"
            aria-label="เบอร์โทรศัพท์"
            autoComplete="username"
          />
        </div>

        <div className="sol-field">
          <input
            type={!showpass ? "text" : "password"}
            id="password"
            name="password"
            value={password}
            onChange={this.onChange}
            className="sol-input"
            aria-label="รหัสผ่าน"
            placeholder="กรอกรหัสผ่าน"
            autoComplete="current-password"
          />
          <span className="sol-eye" role="button" onClick={this.changepass}>
            <svg style={{ display: (!showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="currentColor" viewBox="0 0 16 16">
              <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
              <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
            </svg>
            <svg style={{ display: (showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
            </svg>
          </span>
        </div>

        <div className="sol-row">
          <label className="sol-remember">
            <input
              type="checkbox"
              checked={rememberPass}
              onChange={this.onToggleRemember('rememberPass')}
            />
            <span>จดจำข้อมูลของฉัน</span>
          </label>
          <a className="sol-forgot" role="button" onClick={(e) => e.preventDefault()}>ลืมรหัสผ่าน</a>
        </div>

        <button type="submit" className="sol-btn sol-btn-login" onClick={this.login}>
          เข้าสู่ระบบ
        </button>
      </form>
    );
  }
}

export default App;
